<div class="ion-padding ion-text-center">
  <ion-spinner></ion-spinner>
  <p class="fs-xs">{{ 'general.loading_data' | translate }}</p>
</div>
